/**
 * Data layer for `datacenter-ip-database-aws-gcp-azure-do-linode-ovh`. Thin typed fetch wrappers over /api/v1/datacenter-ip-database-aws-gcp-azure-do-linode-ovh.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface DatacenterIpDatabaseAwsGcpAzureDoLinodeOvhRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListDatacenterIpDatabaseAwsGcpAzureDoLinodeOvhResponse {
	count: number;
	items: DatacenterIpDatabaseAwsGcpAzureDoLinodeOvhRow[];
}

export interface CreateDatacenterIpDatabaseAwsGcpAzureDoLinodeOvhBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/datacenter-ip-database-aws-gcp-azure-do-linode-ovh";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListDatacenterIpDatabaseAwsGcpAzureDoLinodeOvhResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListDatacenterIpDatabaseAwsGcpAzureDoLinodeOvhResponse>(res);
}

export async function create(body: CreateDatacenterIpDatabaseAwsGcpAzureDoLinodeOvhBody): Promise<DatacenterIpDatabaseAwsGcpAzureDoLinodeOvhRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<DatacenterIpDatabaseAwsGcpAzureDoLinodeOvhRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const datacenterIpDatabaseAwsGcpAzureDoLinodeOvhQueryKeys = {
	all: ["datacenter-ip-database-aws-gcp-azure-do-linode-ovh"] as const,
	list: () => [...datacenterIpDatabaseAwsGcpAzureDoLinodeOvhQueryKeys.all] as const,
	detail: (id: string) => [...datacenterIpDatabaseAwsGcpAzureDoLinodeOvhQueryKeys.all, id] as const,
};
